import CategoryRefBlockData from 'Models/Content/CategoryRefBlockData';
import React, {useEffect, useState} from 'react';
import ContentSlider, {SliderItem} from './ContentSlider';
import TabButton from './TabButton';

export type ContentCategory = {id: number; name: string};

type ContentProps = {
  categories: ContentCategory[];
  sliders: SliderItem[];
};

const ContentCategories = ({categories, sliders}: ContentProps) => {
  const [selectedCategory, setSelectedCategory] = useState(categories[0].id);
  const [filteredContent, setFilteredContent] = useState<SliderItem[]>(null);

  useEffect(() => {
    const filteredItems = sliders.filter((item) =>
      item.relatedCategory.expandedValue.some((selectedItem: CategoryRefBlockData) => {
        return selectedItem.id.value == selectedCategory;
      }),
    );
    setFilteredContent(filteredItems);
  }, [selectedCategory]);

  return (
    <>
      <div className='ContentCategories' role='tablist' aria-label='קטגוריות תוכן'>
        {categories.length > 1 ? (
          categories.map(({id, name}) => (
            <TabButton
              key={id}
              onClick={() => setSelectedCategory(id)}
              title={name}
              selected={selectedCategory === id}
              controls={`content-${id}`}
            />
          ))
        ) : (
          <>
            <TabButton onClick={() => {}} title={categories[0].name} selected={false} controls={`content-${categories[0].id}`} />
          </>
        )}
      </div>

      {filteredContent?.length > 0 && (
        <div key={selectedCategory} role='tabpanel' id={`content-${selectedCategory}`}>
          <ContentSlider items={filteredContent} />
        </div>
      )}
    </>
  );
};

export default ContentCategories;
